import { render, staticRenderFns } from "./LeadCloseDialog.vue?vue&type=template&id=052a1083"
import script from "./LeadCloseDialog.vue?vue&type=script&lang=ts"
export * from "./LeadCloseDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports